import { toast } from "react-toastify";

import { useMutation } from "@apollo/client";
import { USER_ARPS } from "constants/settings.constants";

import { DELETE_FORECAST, FOLDERS_LIGHT } from "../../../api/userArps";
import { ORG_FORECAST_ID } from "../constants/constants";

type idsToDelete = {
  folderId: string;
  id: string;
  type: string;
};

export const useDeleteOrganizationForecast = () => {
  const [deleteForecastMutation, { loading, error }] = useMutation(DELETE_FORECAST);
  const deleteForecast = async (idsToDelete: idsToDelete[]) => {
    await deleteForecastMutation({
      variables: {
        input: {
          ids: idsToDelete,
          projectId: ORG_FORECAST_ID,
          type: USER_ARPS
        }
      },
      refetchQueries: [FOLDERS_LIGHT],
      onError: (err) => {
        toast.error(err.message);
      }
    });
  };

  return { delete: deleteForecast, loading, error };
};
